export default "__VITE_ASSET__CSL33sxX__"